<template>
  <div class="page">
    <ion-grid fixed v-if="charger">
      <ion-row class="row-divider"></ion-row>
      <ion-row class="rectangle">
        <ion-col>
          <ion-row align-items-stretch>
            <ion-col class="col-padding">
              <ion-label class="section-head">Basic Details</ion-label>
            </ion-col>
          </ion-row>
          <ion-row align-items-stretch>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Charger ID
              </ion-label>
              <div class="section-desc margin-top-10">
                {{charger.id}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Manufacturer
              </ion-label>
              <div class="section-desc margin-top-10">
                {{charger.manufacturer}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Serial No
              </ion-label>
              <div class="section-desc margin-top-10">
                {{charger.serialNumber}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Charger Type
              </ion-label>
              <div class="section-desc margin-top-10">
                <!-- {{chargerType.name}} -->
                {{chargerType.id}} 
              </div>
            </ion-col>
          </ion-row>
          <ion-row align-items-stretch>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Input Voltage
              </ion-label>
              <div class="section-desc margin-top-10">
                {{chargerType.inputVoltage}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Input Phase
              </ion-label>
              <div class="section-desc margin-top-10">
                {{chargerType.inputPhase}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Primary Communication Method
              </ion-label>
              <div class="section-desc margin-top-10">
                {{charger.primaryCommunicaiton.name}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Secondary Communication Method
              </ion-label>
              <div class="section-desc margin-top-10">
                {{charger.secondaryCommunicaiton.name}}
              </div>
            </ion-col>
          </ion-row>
          <ion-row align-items-stretch>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Charger Output Type
              </ion-label>
              <div class="section-desc margin-top-10">
                {{chargerType.chargerOutputType}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Pending From
              </ion-label>
              <div class="section-desc margin-top-10">
                {{changeDateFormatWithoutTime(charger.pndEffectiveOn)}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Retired On
              </ion-label>
              <div class="section-desc margin-top-10">
                {{changeDateFormatWithoutTime(charger.retEffectiveOn)}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Status
              </ion-label>
              <div class="section-desc status-small margin-top-10" 
              v-bind:class="[{'new': charger.status.id == 'A'}, {'new': charger.status.id == 'PND'}, {'new': charger.status.id == 'RMV'}, {'inactive': charger.status.id == 'RET'}, {'installed': charger.status.id == 'INS'}, {'installed': charger.status.id == 'I'}]">
                {{convertUppercase(charger.status.name)}}
              </div>
            </ion-col>
          </ion-row>

          <hr />

          <div
            v-for="(output, index) in charger ? charger.outputs : ''"
            :key="index"
          >
            <ion-row align-items-stretch>
              <ion-col class="col-padding">
                <ion-label class="section-head">Output {{index + 1}}</ion-label>
              </ion-col>
            </ion-row>
            <ion-row align-items-stretch>
              <!-- Below code is commented by vinoth on 29.04.2021 as per new requirement -->
              <!-- <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Tag No
                </ion-label>
                <div class="section-desc margin-top-10">
                  {{output.tag}}
                </div>
              </ion-col> -->
              <!-- Below output type code is added by vinoth on 29.04.2021 as per new requirement -->
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Output Type
                </ion-label>
                <div class="section-desc margin-top-10">
                  {{output.type.outputType}}
                </div>
              </ion-col>

              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Output Voltage
                </ion-label>
                <div class="section-desc margin-top-10">
                  {{output.type.volt}}
                </div>
              </ion-col>
              
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Output KW Start
                </ion-label>
                <div class="section-desc margin-top-10">
                  {{output.type.kwRange.start}}
                </div>
              </ion-col>
              
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Output KW End
                </ion-label>
                <div class="section-desc margin-top-10">
                  {{output.type.kwRange.end}}
                </div>
              </ion-col>
            </ion-row>
            <!-- Below Output Current Start code is replaced with Output Current by vinoth on 29.04.2021 as per new requirement -->
            <ion-row align-items-stretch>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Output Current
                </ion-label>
                <div class="section-desc margin-top-10">
                  {{output.type.currentRange.start}}
                </div>
              </ion-col>
              <!-- Below code is commented by vinoth on 29.04.2021 as per new requirement -->
              <!-- <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Output Current End
                </ion-label>
                <div class="section-desc margin-top-10">
                  {{output.type.currentRange.end}}
                </div>
              </ion-col> -->
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  No.of Charing Ports
                </ion-label>
                <div class="section-desc margin-top-10">
                  {{output.ports ? output.ports.length : null}}
                </div>
              </ion-col>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Status
                </ion-label>
                <div class="section-desc margin-top-10" v-bind:class="[{'status-active': output.status.id == 'A'}, {'status-inactive': output.status.id == 'I'}]">
                  {{convertUppercase(output.status.name)}}
                </div>
              </ion-col>
            </ion-row>

            <ion-row
              align-items-stretch
              v-for="(port, index) in output.ports"
              :key="index"
            >
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">Charging Port - {{index + 1}}</ion-label>
              </ion-col>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">Charging Port Type</ion-label>
                <div class="section-desc margin-top-10">
                  {{port.type}}
                </div>
              </ion-col>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">Status</ion-label>
                <div class="section-desc margin-top-10" v-bind:class="[{'status-active': port.status.id == 'A'}, {'status-inactive': port.status.id == 'I'}]">
                  {{convertUppercase(port.status.name)}}
                </div>
              </ion-col>
            </ion-row>
            <hr class="thick-line"/>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue"
import { IonGrid, IonRow, IonCol, IonLabel, IonSpinner } from "@ionic/vue";
import { EVChargerService } from "../../service/evcstation/charger.service";
import { migratedTryParseServiceError } from "../../service";
import moment from "moment";

export default defineComponent ({
  name: 'chargerView',
  components: {
    IonGrid, IonRow, IonCol, IonLabel, IonSpinner
  },
  data() {
    return {
      loaderTab: true,
      charger: null,
      chargerType: null
    }
  },
  async mounted() {
    try {
      // let types = await new EVChargerService().chargerTypes();
      // let charger = await new EVChargerService().chargerWithId(this.$route.params.chargerId);
      // if (charger) {
      //   this.charger = charger;
      //   let chargerType = types.find(
      //       chargerType => chargerType.id === charger.type.id
      //   );
      //   this.chargerType = chargerType;
      // }
      await new EVChargerService().chargerTypes().then((types) => {
        new EVChargerService().chargerWithId(this.$route.params.chargerId).then((charger) => {
          if (charger) {
            this.charger = charger;
            let chargerType = types.find(
                chargerType => chargerType.id === charger.type.id
            );
            this.chargerType = chargerType;
          }
        }).catch((error) => {
          this.loaderTab = false;
          let serviceError = migratedTryParseServiceError(error);
          new ToastUtils().presentToast(serviceError.description);
        })
      }).catch((error) => {
        this.loaderTab = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      })
      this.loaderTab = false;
    } catch(error) {
      this.loaderTab = false;
      // new ToastUtils().presentToast(error.response.data.errors[0].detail);
      let serviceError = migratedTryParseServiceError(error);
      new ToastUtils().presentToast(serviceError.description);
    }
    
  },
  methods: {
    changeDateFormat(dateValue) {
      return moment(dateValue).format('DD/MMM/YYYY HH:mm')
    },
    changeDateFormatWithoutTime(dateValue) {
      if(dateValue != null) {
        return moment(dateValue).format('DD/MMM/YYYY')
      }
      
    },
    convertUppercase(value) {
      return value.toUpperCase()
    },
    editCharger() {
    this.$parent.editCharger();
    }
  }
})
</script>

<style scoped>
.btn-secondary {
  height: 47px;
  --background: #21315d !important;
  color: #ffffff;
  border-radius: 3px;
  --background-focused: #21315d !important;
  --background-hover: #21315d !important;
  --webkit-background-focused: #21315d !important;
  --webkit-background-hover: #21315d !important;
}
</style>